import { withNamespace } from "components/Form/FormikControls";
import { toFriendlyName } from "containers/Settings/RuleBooks/Rules/CustomRules/lib";
import { useFieldValue } from "hooks";
import { useSelector } from "react-redux";
import { selectLedgerAccountOptionsForRuleBuilder } from "selectors";
import { Row } from "components/Layout";
import { SubtleBadge } from "components/Badge";
import { CollapseLabel } from "components/Form";
import React from "react";

export function ValueHeader() {
  const ns = "value";

  const unitPriceName = withNamespace(ns, "amount");
  const offsetName = withNamespace(ns, "offset");
  const unitsName = withNamespace(ns, "units");
  const multiplierName = withNamespace("", "price_multiplier");

  const unitPrice = toFriendlyName(useFieldValue(unitPriceName));
  const units = toFriendlyName(useFieldValue(unitsName));
  const priceMultiplier = toFriendlyName(useFieldValue(multiplierName));
  const offset = toFriendlyName(useFieldValue(offsetName));

  const glCodeField = useFieldValue("gl_code") || {};
  const glCode = glCodeField.value || null;
  const ledgerAccountOptions = useSelector(
    selectLedgerAccountOptionsForRuleBuilder,
  );
  const ledgerAccountOption =
    ledgerAccountOptions.find(option => option.value === glCode) || {};

  return (
    <Row>
      <div>
        <SubtleBadge>Value</SubtleBadge>
      </div>

      <Row alignCenter flexWrap>
        <CollapseLabel>
          {offset !== "0" && `${offset} + `} {units} * {unitPrice}
          {priceMultiplier !== "1" && ` * ${priceMultiplier}`}
        </CollapseLabel>
        <CollapseLabel>{ledgerAccountOption.label}</CollapseLabel>
      </Row>
    </Row>
  );
}
